import React from "react";
import PropTypes from "prop-types";
import { OrderedMap } from "immutable";

import { Statistic } from "antd";

const ANALYSIS_LIST = new OrderedMap({
    average_monthly_balance: {
        label: "Average Monthly Balance",
        value: 0
    },
    total_inward_cheques: {
        label: "Total Inward Cheques",
        value: 0
    },
    inward_cheque_bounce_perc: {
        label: "Inward Cheque Bounce (%)",
        value: 0
    },
    total_outward_cheques: {
        label: "Total Outward Cheques",
        value: 0
    },
    outward_cheque_bounce_perc: {
        label: "Outward Cheque Bounce (%)",
        value: 0
    },
    avg_bank_balance_to_limit_perc: {
        label: "Average Bank Balance to Limit (%)"
    }
});

class BankStatementAnalysisList extends React.Component {
    createStatementAnalysis() {
        if (this.props.statements) {
            const data = this.props.statements.toList().reduce(
                (agg, _) => {
                    agg.balance += _.total_balance;
                    agg.inward_cheque += _.total_inward_cheque;
                    agg.outward_cheque += _.total_outward_cheque;
                    agg.outward_cheque_bounce += _.total_outward_cheque_bounce;
                    agg.inward_cheque_bounce += _.total_inward_cheque_bounce;
                    return agg;
                },
                {
                    balance: 0,
                    inward_cheque_bounce: 0,
                    inward_cheque: 0,
                    outward_cheque_bounce: 0,
                    outward_cheque: 0
                }
            );
            return new OrderedMap({
                average_monthly_balance: {
                    label: "Average Monthly Balance",
                    value: this.props.statements.size
                        ? Math.round(
                            data.balance /
                                  (this.props.statements.size *
                                      this.props.statements.first().key_size)
                        )
                        : "--"
                },
                total_inward_cheques: {
                    label: "Total Inward Cheques",
                    value: data.inward_cheque
                },
                inward_cheque_bounce_perc: {
                    label: "Inward Cheque Bounce (%)",
                    value: data.inward_cheque > 0 ? Math.round(
                        (data.inward_cheque_bounce / data.inward_cheque) * 100
                    ) : "0%",
                    getClassName() {
                        if (this.value > 3) {
                            return "flash-red";
                        }
                        return "";
                    }
                },
                total_outward_cheques: {
                    label: "Total Outward Cheques",
                    value: data.outward_cheque
                },
                outward_cheque_bounce_perc: {
                    label: "Outward Cheque Bounce (%)",
                    value: data.outward_cheque > 0 ? Math.round(
                        (data.outward_cheque_bounce / data.outward_cheque) * 100
                    ) : "0%"
                },
                avg_bank_balance_to_limit_perc: {
                    label: "Average Bank Balance to Limit (%)",
                    value:
                        this.props.limit && this.props.statements.size
                            ? (
                                (data.balance /
                                      (this.props.statements.size *
                                          this.props.statements.first()
                                              .key_size) /
                                      this.props.limit) *
                                  100
                            ).toFixed(1)
                            : "0%"
                }
            });
        }
        return ANALYSIS_LIST;
    }
    render() {
        const data = this.createStatementAnalysis();
        return (
            <div className={"d-flex justify-content-space-between p-10"}>
                {data
                    .map(_ => (
                        <Statistic
                            key={_.label}
                            title={_.label}
                            className={_.getClassName && _.getClassName()}
                            value={
                                !isNaN(_.value) &&
                                _.label !== "Average Monthly Balance"
                                    ? _.value + "%"
                                    : !isNaN(_.value) &&
                                      _.label === "Average Monthly Balance"
                                        ? _.value
                                        : "--"
                            }
                        />
                    ))
                    .toList()
                    .toArray()}
            </div>
        );
    }
}

BankStatementAnalysisList.propTypes = {
    statements: PropTypes.object,
    data: PropTypes.object,
    styleProp: PropTypes.string,
    limit: PropTypes.number
};

export default BankStatementAnalysisList;
